import Swiper from 'swiper'
import { Navigation, Pagination, Thumbs, Autoplay, EffectCards } from 'swiper/modules'

Swiper.use([Pagination, Navigation, Thumbs, Autoplay, EffectCards])

export const SwiperImpl = Swiper
